import axios from 'axios';

const buildUrl = (accountId, assistantId) =>
  `/api/v1/accounts/${accountId}/pipeline_brain/assistants/${assistantId}/documents`;

export default {
  list(accountId, assistantId) {
    return axios.get(buildUrl(accountId, assistantId));
  },

  get(accountId, assistantId, path) {
    return axios.get(`${buildUrl(accountId, assistantId)}/${encodeURIComponent(path)}`);
  },

  autosave(accountId, assistantId, path, content) {
    return axios.put(`${buildUrl(accountId, assistantId)}/${encodeURIComponent(path)}`, {
      content,
    });
  },

  push(accountId, assistantId, path, { message, baseSha } = {}) {
    return axios.post(
      `${buildUrl(accountId, assistantId)}/${encodeURIComponent(path)}/push`,
      { message, base_sha: baseSha }
    );
  },

  discard(accountId, assistantId, path) {
    return axios.post(
      `${buildUrl(accountId, assistantId)}/${encodeURIComponent(path)}/discard`
    );
  },
};
